var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12616",
    "data-name": "Group 12616",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.081,
    height: 31.502,
    viewBox: "0 0 33.081 31.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3014",
    "data-name": "Rectangle 3014",
    width: 33.081,
    height: 31.502,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12615",
    "data-name": "Group 12615",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39344",
    "data-name": "Path 39344",
    d: "M0,42.432a3.992,3.992,0,0,1,4.124-4.053A4.086,4.086,0,0,1,8.19,42.41a4.185,4.185,0,0,1-4.107,4.158A4.068,4.068,0,0,1,0,42.432",
    transform: "translate(0 -28.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39345",
    "data-name": "Path 39345",
    d: "M89.472,4.3A4.067,4.067,0,0,1,85.2,8.222,4.112,4.112,0,1,1,89.472,4.3",
    transform: "translate(-60.959 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39346",
    "data-name": "Path 39346",
    d: "M74.139,93.749a4.063,4.063,0,1,1,8.125-.013,4.063,4.063,0,0,1-8.125.013",
    transform: "translate(-55.621 -67.258)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39347",
    "data-name": "Path 39347",
    d: "M21.1,3c-5.255.438-8.867,2.886-10.743,7.4l-4.4.473C6.876,5.533,15.105,1.025,21.1,3",
    transform: "translate(-4.466 -1.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39348",
    "data-name": "Path 39348",
    d: "M112.651,19.955l1.622-4.184c3.579,3.109,5.26,12.159-.137,17.169,2.014-5.867,1.66-8.769-1.485-12.985",
    transform: "translate(-84.514 -11.832)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39349",
    "data-name": "Path 39349",
    d: "M22.081,89.315c2.411,3.292,5.33,5.277,9.169,5.318,1.8.019,3.246.026,3.954,2.024.184.521.856.868,1.3,1.293-4.559,2.259-13.076-2.678-14.424-8.635",
    transform: "translate(-16.566 -67.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39350",
    "data-name": "Path 39350",
    d: "M29.151,16.846c.923-5.166,7.156-8.827,12.027-7.441.12,1.3.239,2.6.364,3.966-2.086-.668-4.33-1.456-6.726-.878a8.881,8.881,0,0,0-5.665,4.353",
    transform: "translate(-21.87 -6.834)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39351",
    "data-name": "Path 39351",
    d: "M20.585,69l3.34-2.264c.5,5.019,2.774,8.681,8.516,9.4-4.575,1.6-10.589-2.191-11.857-7.14",
    transform: "translate(-15.443 -50.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39352",
    "data-name": "Path 39352",
    d: "M95.78,36.58c3.573,2.855,3.333,10.463-.213,13.667l-3.526-1.722c3.992-2.968,5.973-6.749,3.739-11.945",
    transform: "translate(-69.052 -27.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39353",
    "data-name": "Path 39353",
    d: "M51.055,49.975h-3.2V47.046h3.186V43.662h2.794v3.371h3.2v2.946H53.841v3.374H51.055Z",
    transform: "translate(-35.899 -32.756)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.7e0e26c9.svg";
export { ForwardRef as ReactComponent };